import { useRef } from 'react';

function hashObject(obj) {
    const str = JSON.stringify(obj);
    let hash = 5381;
    for (let i = 0; i < str.length; i++) {
        hash = (hash * 33) ^ str.charCodeAt(i);
    }
    return hash >>> 0;
}

export default function useAppHashCompare(value) {
    const prevHash = useRef(null);

    const currentHash = hashObject(value);
    const hasChanged = prevHash.current !== currentHash;

    if (hasChanged) {
        prevHash.current = currentHash;
    }

    return prevHash.current;
}